export default "__VITE_ASSET__8a2a99c9__"